import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { initDatadog } from '@cartwhl/tracking/datadog';
import { authStore, userStore } from 'stores/global';

import App from './App';
import './index.css';

// Initialize stores
authStore.init();
userStore.setTheme('light');

const disambiguator = import.meta.env.VITE_API_DISAMBIGUATOR ?? 'unknown';
const env = disambiguator === '' ? 'prod' : disambiguator;

initDatadog({
  service: 'homepage',
  env,
  isDevelopment: process.env.NODE_ENV === 'development',
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
